<template>
  <div>
    <div class="conmmit-title">
      <el-divider direction="vertical"></el-divider>评论交流
    </div>
    <div>
      <el-input type="text" prefix-icon="el-icon-edit" placeholder="书写评论..." v-model="myInput" maxlength="140" show-word-limit></el-input>
      <div style="text-align:right;margin-top:24px">
        <el-button class="reply-btn" size="medium" round @click="handMySpeech()" style="background:#44A8F3;color:#fff">发表评论</el-button>
      </div>
    </div>
    <div v-for="(item,i) in commentsData" :key="i" class="author-title reply-father">
      <el-row type="flex">
        <el-col :span="3" style="text-align:center">
          <el-avatar class="header-img" :size="84">{{item.userName}}</el-avatar>
        </el-col>
        <el-col :span="21">
          <div class="author-info">
            <div class="author-name">{{item.userName}}</div>
            <div class="author-content">{{item.content}}</div>
            <el-row>
              <el-col :span="20">
                <span class="author-time">{{item.createTime}}</span>
              </el-col>
              <el-col :span="4">
                <div class="icon-btn">
                  <el-button type="text" icon="el-icon-s-comment" @click="handClickComments(item,i)">回复</el-button>
                  <el-button type="text" :icon="item.show?'el-icon-caret-top':'el-icon-caret-bottom'" @click="handClickShow(item)">{{`${item.show?'收起':'展开'}(${item.replyCount})`}}</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <div class="reply-box" v-show="item.show">
        <div v-for="(reply,j) in item.replyList" :key="j" class="author-title">
          <el-row>
            <el-col :span="3" style="text-align:center">
              <el-avatar class="header-img" :size="60">{{reply.userName}}</el-avatar>
            </el-col>
            <el-col :span="21">
              <div class="author-info">
                <div class="author-name">{{reply.userName}}</div>
                <div class="author-content">{{`回复 ${reply.replyName}:${reply.content}`}}</div>
                <el-row>
                  <el-col :span="20">
                    <span class="author-time">{{reply.createTime}}</span>
                  </el-col>
                  <el-col :span="4">
                    <div class="icon-btn">
                      <el-button icon="el-icon-s-comment" type="text" @click="handClickComments(reply,i)">回复</el-button>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div v-show="item.inputShow" class="my-reply my-comment-reply">
        <el-row>
          <el-col :offset="2" :span="22">
            <div class="submit-commit">
              <el-input v-model="input" :placeholder="`回复 ${replyObj.userName}`" maxlength="140" show-word-limit>
                <el-button slot="append" @click="handSpeech(item)" style="background:#44A8F3;color:#fff">发布</el-button>
              </el-input>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getReviewList, addReview, addReviewReply } from '@/api/system/deptReview'
export default {
  name: 'ArticleComment',
  props: {
    setId: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      input: '',
      myInput: '',
      replyObj: {},
      myName: 'Lana Del Rey',
      myHeader: 'https://ae01.alicdn.com/kf/Hd60a3f7c06fd47ae85624badd32ce54dv.jpg',
      commentsData: [],
    }
  },
  computed: {
    ...mapGetters(['token', 'userInfo']),
  },
  methods: {
    ...mapActions(['setLoginVisible']),
    handClickShow(item) {
      item.show = !item.show
    },
    handMySpeech() {
      if (!this.token) this.setLoginVisible(true)
      else {
        let params = {
          deptId: this.setId,
          userId: this.userInfo.id,
          content: this.myInput
        }
        addReview(params).then(() => {
          this.$message.success("评论成功");
          this.$emit('close')
          this.getReviews()
          this.myInput = ''
        });
      }
    },
    handSpeech() {
      if (!this.input.length) {
        this.$message.warning('评论不能为空!')
        return
      }
      if (!this.token) this.setLoginVisible(true)
      else {
        let params
        if (this.replyObj.parentId) {
          params = {
            parentId: this.replyObj.parentId,
            userId: this.userInfo.id,
            replyName: this.replyObj.userName,
            lastId: this.replyObj.id,
            content: this.input
          }
        } else {
          params = {
            parentId: this.replyObj.id,
            userId: this.userInfo.id,
            replyName: this.replyObj.userName,
            content: this.input
          }
        }
        addReviewReply(params).then(() => {
          this.$message.success("回复成功");
          this.$emit('close')
          this.getReviews()
        });
      }
    },
    handClickComments(item, i) {
      this.commentsData.map((m, n) => {
        if (!(n === i)) {
          m.inputShow = false
        }
      })
      this.commentsData[i].inputShow = !this.commentsData[i].inputShow
      this.input = ''
      this.replyObj = item
    },
    getReviews() {
      let deptId = this.setId
      getReviewList(deptId).then(res => {
        this.commentsData = res
        this.commentsData.map((m) => {
          this.$set(m, 'inputShow', false)
          this.$set(m, 'show', false)
        })
      })
    },

    dateStr(date) {
      //获取js 时间戳
      var time = new Date().getTime();
      //去掉 js 时间戳后三位，与php 时间戳保持一致
      time = parseInt((time - date) / 1000);
      //存储转换值 
      var s;
      if (time < 60 * 10) {//十分钟内
        return '刚刚';
      } else if ((time < 60 * 60) && (time >= 60 * 10)) {
        //超过十分钟少于1小时
        s = Math.floor(time / 60);
        return s + "分钟前";
      } else if ((time < 60 * 60 * 24) && (time >= 60 * 60)) {
        //超过1小时少于24小时
        s = Math.floor(time / 60 / 60);
        return s + "小时前";
      } else if ((time < 60 * 60 * 24 * 30) && (time >= 60 * 60 * 24)) {
        //超过1天少于30天内
        s = Math.floor(time / 60 / 60 / 24);
        return s + "天前";
      } else {
        //超过30天ddd
        var dateD = new Date(parseInt(date));
        return dateD.getFullYear() + "/" + (dateD.getMonth() + 1) + "/" + dateD.getDate();
      }
    }
  },
  created() {
    this.getReviews()
  }


}
</script>
<style lang="less" scoped>
.el-input-group__append,
.el-input-group__prepend {
  background-color: #43c34b;
}
.conmmit-title {
  padding-bottom: 12px;
  font-size: 18px;
  color: #333;
  .el-divider--vertical {
    width: 2px;
    background: #44a8f3;
  }
}
.my-reply {
  padding: 10px;
  // background-color: #fafbfc;

  .header-img {
    display: inline-block;
    vertical-align: top;
  }

  .reply-info {
    display: inline-block;
    margin-left: 5px;
    width: 90%;

    @media screen and (max-width: 1200px) {
      width: 80%;
    }

    .reply-input {
      min-height: 20px;
      line-height: 22px;
      padding: 10px 10px;
      color: #ccc;
      background-color: #fff;
      border-radius: 5px;

      &:empty:before {
        content: attr(placeholder);
      }

      &:focus:before {
        content: none;
      }

      &:focus {
        padding: 8px 8px;
        border: 2px solid blue;
        box-shadow: none;
        outline: none;
      }
    }
  }

  .reply-btn-box {
    height: 25px;
    margin: 10px 0;

    .reply-btn {
      position: relative;
      float: right;
      margin-right: 15px;
    }
  }
}

.my-comment-reply {
  margin-left: 50px;

  .reply-input {
    width: flex;
  }
  .submit-commit{
    margin: 12px 0 6px 0;
  }
}

.author-title {
  padding: 10px;
  border-bottom: 1px solid rgba(178, 186, 194, 0.3);
  .header-img {
    display: inline-block;
    vertical-align: top;
  }

  .author-info {
    .author-name {
      color: #333;
      font-size: 14px;
      font-weight: 600;
      margin-top: 6px;
    }
    .author-content {
      color: #666;
      height: 32px;
      margin: 4px 0;
      line-height: 16px;
      font-size: 14px;
    }

    .author-time {
      color: #999;
      font-size: 14px;
    }
  }

  .icon-btn {
    text-align: center;
    // width: 30%;
    // padding: 0 !important;
    // float: right;
    .el-button {
      padding: 0;
      color: #999;
    }
    .el-button:hover {
      color: #44A8F3;
    }
    > span {
      cursor: pointer;
    }

    .iconfont {
      margin: 0 5px;
    }
  }

  .talk-box {
    margin: 0 50px;

    > p {
      margin: 0;
    }

    .reply {
      font-size: 16px;
      color: #000;
    }
  }

  .reply-box {
    margin: 10px 0 0 50px;
    // background-color: #efefef;
  }
}
</style>
